const initialState = {
    gemStone: [],
    images: [],
    history: [],
    classfication:[],
    market:[],
    horscope: [],
    genuinity:[],
    anniversary:[]
}
const gemstoneReducers = function(state=initialState,action){
    
    switch(action.type){
     
        case 'Get-GEMSTONE': {
            
            return {
                ...state,
                gemStone: [...action.payload],
            }
        }
        case 'Get-IMAGE': {
           
            return {
                ...state,
                images: [...action.payload],
            }
        }
        case 'Get-HISTORY': {
            
            return {
                ...state,
                history: [...action.payload],
            }
        }
        case 'Get-CLASSFICATION': {
           
            return {
                ...state,
                classfication: [...action.payload],
            }
        }
        case 'Get-Market': {
           
            return {
                ...state,
                market: [...action.payload],
            }
        }
        case 'Get-HORESCOPE':{
            return {
                ...state,
                horscope: [...action.payload],
            }
        }
        case 'Get-Genuinity':{
            return {
                ...state,
                genuinity: [...action.payload],
            }
        }
      case 'Get-Anniversary':{
          return {
              ...state,
              anniversary: [...action.payload],
          }
      }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default gemstoneReducers